import * as React from 'react'

interface Props<T> {
  placeholder?: string
  value: T
  className?: string
  style?: React.CSSProperties
  onChange?: (value: T) => void
  onClick: () => void
}

export default React.forwardRef(function FakeInputComponent<T extends React.ReactNode> ({ placeholder, value, className, style = {}, onClick, onChange }: Props<T>, ref: React.Ref<HTMLDivElement>) {
  const previousValue = React.useRef<T>(null)

  React.useEffect(() => {
    if (onChange && previousValue.current !== value) {
      previousValue.current = value
      onChange(value)
    }
  }, [onChange, value])

  return <div ref={ ref } className={ `fakeInput ${!value ? 'has-placeholder' : ''} ${className}` } style={ style } onClick={ onClick }>
    { value || placeholder }
  </div>
})
